import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
    iconfont: 'fa',
    icons: {
        menu: 'fas fa-bars'
    }
});
